export default __webpack_public_path__ + "maps-examples-animate-image-layer-1200-9fbaf7a829b23b98a8486bfbcaacccf7.webp";